export default __webpack_public_path__ + "static/media/10S.5ffe1ec5.webp";